import type { StateWithPopup, StoragePopupType } from './reducer'

export const getPopupQueue = (state: StateWithPopup): StoragePopupType[] =>
    state.popup.queue
